<template>
  <page>
    <template slot="content">
      <q-and-a-content :title="'マイルを使う'">
        <template slot="content">
          <div class="text">スライドメニューから<b>Weマイル残高</b>をタップするとマイル明細が表示されます。<b>マイルを使う</b>をタップするとWeStoreの商品を確認できます。WeStoreでは毎日数量限定での販売となっています。</div>
          <img class="picture" src="../assets/images/q_and_a/11.png">
          <div class="text">購入したい商品を選択し、詳しい送付先情報及びサイズや色などの補足情報を入力し、決済手続きを行い決算完了が表示されたら注文完了となり、注文情報は注文履歴にてご確認いただけます。決済待ちのご注文は24H内に自動的にキャンセルされるため、予めご了承ください。なお、自動キャンセルされたご注文の消費済みマイルは2日後に返還されます。</div>
          <img class="picture" src="../assets/images/q_and_a/12.png">
          <img class="picture" src="../assets/images/q_and_a/13.png">
          <img class="picture" src="../assets/images/q_and_a/14.png">
        </template>
      </q-and-a-content>
    </template>
  </page>
</template>

<script>
  import Page from '@/components/Page'
  import QAndAContent from '@/components/QAndAContent.vue'

  export default {
    name: 'QAndABean',
    components: {
      Page,
      QAndAContent
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesBean.vue